import { put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../../actions/actionConstants";

//Auth
import { auth } from "./../../firebase";

function* handleReset(action) {
  /*

    RESET PASS

  */
  const errors = auth.doPasswordReset(action.email);
  console.log(errors);
  yield put({
    type: ACTIONS.OPEN_SNACKBAR,
    payload: {
      variant: "success",
      message: `sent reset email to: ${action.email}`
    }
  });
}

export function* resetSaga() {
  yield takeEvery(ACTIONS.RESET_PASSWORD, handleReset);
}



// WEBPACK FOOTER //
// ./src/sagas/auth/reset.js